module.exports = __webpack_public_path__ + "static/media/nh-icon-outsourcing.03b1ce1f.png";